module.exports = __webpack_public_path__ + "media/images/application/choose-price/poulpe-06-c7615fe1d1ddc6acfc7ec4ef42738529.svg";